import {
    ActionsEnum,
    CensusEquipmentStatusReasons
} from "../../../processes/massive_actions/CensusCooler/data/models/CensusEnums";
import {
    MappedDetailCountWithFinalAction,
    MappedSummaryWithFinalAction
} from "../../data/types/MappedSummaryWithFinalAction";
import {JSONCensusFinalSummary} from "../../data/models/JSONCensusFinalSummary";
import {Section} from "../../../processes/massive_actions/CensusCooler/pages/CensusStatusPage/types";
import {AccordionContextProps} from "../../../components/DesAccordion/context";

export const mapFinalSummaryGroupedByStatusAndStatusDetail = (
    summary: JSONCensusFinalSummary,
): MappedSummaryWithFinalAction[] => {
    const mappedSummary: MappedSummaryWithFinalAction[] = [];
    summary?.summary?.forEach((summaryItem) => {
        const {statusAndDetailCount, containsMultipleActions} = summaryItem;
        const {
            inventoryStatus,
            inventoryStatusDetail,
            inventoryStatusReason,
            count,
            suggestedAction,
            finalAction
        } = statusAndDetailCount;

        const existingMappedSummary = mappedSummary.find((mappedItem) => {
            return (
                mappedItem.inventoryStatus === inventoryStatus &&
                mappedItem.inventoryStatusDetail === inventoryStatusDetail
            );
        });

        const currentFinalAction = finalAction === undefined && containsMultipleActions ? ActionsEnum.MULTIPLE_SELECTIONS : finalAction;

        if (existingMappedSummary) {
            const prevReason: MappedDetailCountWithFinalAction = {
                count: existingMappedSummary.count,
                inventoryStatusReason: existingMappedSummary.inventoryStatusReason ?? CensusEquipmentStatusReasons.OTHER,
                suggestedAction: existingMappedSummary.suggestedAction,
                finalAction: existingMappedSummary.finalAction
            };
            existingMappedSummary.withReason.push(prevReason);

            existingMappedSummary.count += count;
            existingMappedSummary.suggestedAction = undefined;
            existingMappedSummary.inventoryStatusReason = undefined;
            existingMappedSummary.finalAction = undefined;
            existingMappedSummary.withReason.push({
                count,
                inventoryStatusReason: inventoryStatusReason ?? CensusEquipmentStatusReasons.OTHER,
                suggestedAction: suggestedAction ?? ActionsEnum.NO_ACTION,
                finalAction: currentFinalAction ?? ActionsEnum.NO_ACTION
            });
        } else {
            mappedSummary.push({
                count,
                inventoryStatus,
                inventoryStatusDetail,
                inventoryStatusReason,
                suggestedAction: suggestedAction ?? ActionsEnum.NO_ACTION,
                withReason: [],
                finalAction: currentFinalAction ?? ActionsEnum.NO_ACTION
            });
        }
    });
    return mappedSummary;
};

export const mapOpenedSectionsIntoInitialState = (openedSections: Section[]): AccordionContextProps['openSections'][] => {
    const initialSections: AccordionContextProps['openSections'][] = [];
    openedSections?.forEach((section) => {
        const {name, level} = section;
        initialSections[level] = {...initialSections[level], [name]: true};
    })
    return initialSections
}